// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  height: 5vw;
  align-items: center;
  justify-content: center;
}

.itemMacroBox {
  padding: 0vw;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  justify-content: space-evenly;
  gap: 4vw;
  transition: all 0.3s ease-in-out;
  font-family: var(--ion-font-family);
}
.itemMacroBox .menuMacro {
  transition: all 0.3s ease-in-out;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}
.itemMacroBox .menuMacro .macroName {
  margin: 0;
  position: relative;
  letter-spacing: 1px;
  padding: 0px;
  transition: all 0.3s ease-in-out;
  align-items: center;
  justify-items: center;
  transform: translateY(-3px) translateX(-3px);
  color: var(--name-color);
  font-size: var(--font-size);
  font-weight: 200;
}
.itemMacroBox .menuMacro .macroVal {
  display: flex;
  margin: 0;
  padding: 0;
  transition: all 0.3s ease-in-out;
  align-items: center;
  justify-items: center;
  transform: translateX(0px) translateY(0px);
  color: var(--macro-color);
  font-size: var(--value-size);
  font-weight: 500;
}
.itemMacroBox .menuMacroBig {
  transition: all 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  justify-items: center;
  min-width: 20vw;
}
.itemMacroBox .menuMacroBig .macroNameBig {
  margin: 0px;
  position: relative;
  letter-spacing: 1px;
  padding: 0px;
  transition: all 0.3s ease-in-out;
  align-items: center;
  justify-items: center;
  transform: translateY(0px) translateX(0px);
  font-size: 12px;
  font-weight: 300;
  text-transform: capitalize;
}
.itemMacroBox .menuMacroBig .macroValBig {
  display: flex;
  margin: 0px;
  padding: 0;
  transition: all 0.3s ease-in-out;
  align-items: center;
  justify-items: center;
  transform: translateX(0px) translateY(0px);
  font-size: 14px;
  font-weight: 500;
}

.macrosDb :host .itemMacroBox .menuMacro .macroName {
  transform: translateY(0px) translateX(-3px);
}`, "",{"version":3,"sources":["webpack://./src/app/components/marcos-bar/macros-bar.component.scss"],"names":[],"mappings":"AAAC;EACC,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAIC;EACG,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;EAEA,QAAA;EACA,gCAAA;EACH,mCAAA;AAFD;AAIK;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAFL;AAMK;EAEC,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,qBAAA;EACA,4CAAA;EACA,wBAAA;EACA,2BAAA;EACA,gBAAA;AALN;AAQK;EAGC,aAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;EACA,mBAAA;EACA,qBAAA;EACG,0CAAA;EACH,yBAAA;EACA,4BAAA;EACA,gBAAA;AARN;AAWM;EACD,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AATL;AAaK;EAEC,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,qBAAA;EACA,0CAAA;EAEA,eAAA;EACA,gBAAA;EACA,0BAAA;AAbN;AAiBK;EAGC,aAAA;EACA,WAAA;EACA,UAAA;EACA,gCAAA;EACA,mBAAA;EACA,qBAAA;EACG,0CAAA;EAEH,eAAA;EACA,gBAAA;AAlBN;;AA6BK;EACA,2CAAA;AA1BL","sourcesContent":["\t:host{\n\t\tdisplay: flex;\n\t\theight: 5vw;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t}\n\n\n\t.itemMacroBox {\n    padding: 0vw;\n    display: flex;\n    flex-direction: row;\n    margin: 0 auto;\n    justify-content: space-evenly;\n    // width: 90%;\n    gap: 4vw;\n    transition: all 0.3s ease-in-out;\n\tfont-family: var(--ion-font-family);\n\n\t\t\t\t\t.menuMacro{\n\t\t\t\t\ttransition: all 0.3s ease-in-out;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: row;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\t\n\t\t\t\t\t// height: 3vh;\n\t\t\t\t\t\n\t\t\t\t\t.macroName {\n\t\t\t\t\t\t// font-size: 13px !important;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\t\tpadding: 0px;\n\t\t\t\t\t\ttransition: all 0.3s ease-in-out;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-items: center;\n\t\t\t\t\t\ttransform: translateY(-3px) translateX(-3px);\n\t\t\t\t\t\tcolor: var(--name-color);\n\t\t\t\t\t\tfont-size: var(--font-size);\n\t\t\t\t\t\tfont-weight: 200;\n\t\t\t\t\t}\n\n\t\t\t\t\t.macroVal {\n\t\t\t\t\t\t// numeric macro value\n\t\t\t\t\t\t// font-size: 15px !important;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\ttransition: all 0.3s ease-in-out;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-items: center;\n\t\t\t\t\t    transform: translateX(0px) translateY(0px);\n\t\t\t\t\t\tcolor: var(--macro-color);\n\t\t\t\t\t\tfont-size: var(--value-size);\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\t\t.menuMacroBig{\n\t\t\t\t\ttransition: all 0.3s ease-in-out;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tjustify-items: center;\n\t\t\t\t\tmin-width: 20vw;\n\t\t\t\t\t\n\t\t\t\t\t// height: 3vh;\n\t\t\t\t\t\n\t\t\t\t\t.macroNameBig {\n\t\t\t\t\t\t// font-size: 13px !important;\n\t\t\t\t\t\tmargin: 0px;\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\t\tpadding: 0px;\n\t\t\t\t\t\ttransition: all 0.3s ease-in-out;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-items: center;\n\t\t\t\t\t\ttransform: translateY(0px) translateX(0px);\n\t\t\t\t\t\t// color: var(--name-color);\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tfont-weight: 300;\n\t\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\t\t    \n\t\t\t\t\t}\n\n\t\t\t\t\t.macroValBig {\n\t\t\t\t\t\t// numeric macro value\n\t\t\t\t\t\t// font-size: 15px !important;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tmargin: 0px;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\ttransition: all 0.3s ease-in-out;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-items: center;\n\t\t\t\t\t    transform: translateX(0px) translateY(0px);\n\t\t\t\t\t\t// color: var(--macro-color);\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\n\t\t\t\t}\n\n\t\t\t\t\t.macrosDb{\n\t\t:host{\n\t\t\t.itemMacroBox{\n\t\t\t\t.menuMacro{\n\t\t\t\t\t.macroName {\n\t\t\t\t\ttransform: translateY(0px) translateX(-3px);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
